import type { HttpClient } from '@angular/common/http';
import type { Listing } from '@thevillages/schemas';

import { RedirectCommand, type Router } from '@angular/router';
import { catchError, map, type Observable, of } from 'rxjs';

import { Environment } from '../../../environments/environment';

export function GetByVLS(
  httpClient: HttpClient,
  router: Router,
  id: string,
  token?: string,
): Observable<Listing | RedirectCommand> {
  return httpClient
    .get<Listing[]>(`${Environment.apiUrl}/listings?vls=${id}`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : 'Basic 6501b52adbac5a809447da4f',
      },
    })
    .pipe(
      map((listings) => {
        if (!listings.length) {
          return new RedirectCommand(router.parseUrl('/'));
        }

        return listings[0];
      }),
      catchError(() => {
        // Redirect if the route was not found or if there was an error fetching the listing.
        return of(new RedirectCommand(router.parseUrl('/')));
      }),
    );
}
